<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0"><i class="fas fa-plus-circle mr-2" /> เติมเครดิต</h2>
			</template>
			<template>
				<form @submit.prevent="addCredit">
					<base-input
						label="จำนวนเครดิต"
						placeholder="จำนวนเครดิต"
						v-model.number="credit"
					/>
					<base-input label="หมายเหตุ" placeholder="หมายเหตุ" v-model="remark" />

					<base-input
						label="วัน/เดือน/ปี เวลาที่โอนเงิน"
						placeholder="00/00/0000 00:00"
						v-model="transferDate"
						v-mask="'##/##/#### ##:##'"
					/>

					<base-input label="ธนาคาร" v-if="transferDate != ''" required>
						<el-select v-model="selectBankCode" placeholder="ธนาคาร">
							<el-option :label="bankCode | bankName" :value="bankCode" />
							<el-option label="ทรูมันนี่วอลเล็ท" value="TRUEWALLET" />
						</el-select>
					</base-input>

					<base-input
						label="ยอดคงเหลือขั้นต่ำ"
						placeholder="ยอดคงเหลือขั้นต่ำ"
						v-model.number="minAvailable"
					/>
					<base-input
						label="ยอดถอนสูงสุด"
						placeholder="ยอดถอนสูงสุด"
						v-model.number="maxWithdraw"
					/>

					<div class="text-center">
						<base-button native-type="submit" type="default" icon :disabled="loading">
							<span class="btn-inner--icon">
								<i class="fas fa-check" />
							</span>
							<span class="btn-inner--text">เติมเครดิต</span>
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import MemberService from '../../services/member.service'

export default {
	props: ['open', 'member'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			bankCode: '',
			credit: 0,
			remark: '',
			transferDate: '',
			selectBankCode: '',
			minAvailable: 0,
			maxWithdraw: 0,
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		addCredit() {
			this.loading = true
			MemberService.addCredit(this.member.id, {
				amount: this.credit,
				remark: this.remark,
				transferDate: this.transferDate,
				bankCode: this.selectBankCode,
				minAvailable: this.minAvailable,
				maxWithdraw: this.maxWithdraw,
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('reloadMember')
					this.$emit('close')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	watch: {
		member(v) {
			if (v) {
				this.bankCode = v.bankCode
			}
		},
	},
}
</script>
